'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.mobileProfileIcon {\n  position: relative;\n}\n.mobileProfileIcon__menu {\n  width: 120px;\n  position: absolute;\n  top: 50px;\n  right: calc(0.5 * 1rem);\n  padding: calc(0.75 * 1rem);\n  border: 0.5px solid #c2c2c2;\n  border-radius: calc(0.25 * 1rem);\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n}\n.mobileProfileIcon__menu a {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  text-decoration: none;\n  color: #717171;\n  margin-bottom: calc(0.75 * 1rem);\n}\n.mobileProfileIcon__icon, .mobileProfileIcon__icon--initialName {\n  position: absolute;\n  right: 10px;\n  color: #1D66DD;\n  display: flex;\n  text-decoration: unset;\n  width: 45px;\n  height: 30px;\n}\n.mobileProfileIcon__icon i, .mobileProfileIcon__icon--initialName i {\n  font-size: 24px;\n}\n.mobileProfileIcon__icon--initialName {\n  font-size: 12px;\n  line-height: 20px;\n  font-weight: 400;\n  width: auto;\n  height: calc(2 * 1rem);\n  padding: calc(0.5 * 1rem);\n  background: #E81A1A;\n  color: #ffffff;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n}");
//# sourceMappingURL=MobileProfileIcon.scss.js.map
